export default "__VITE_ASSET__CCnhP0jn__"